import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import substanceDrugsUsageItemValidator from './validators/item';
import { SubstanceDrugsUsageModel } from './types';

const substanceDrugsUsageValidator: ValidateJSModel<SubstanceDrugsUsageModel> = {
  UsedDrugs: { presence: true, hasValue: { validator: hasYesOrNo } },
  List: (value, attributes) => {
    if (attributes?.UsedDrugs && attributes?.UsedDrugs.value === 'Yes') {
      return {
        presence: true,
        accordion: {
          validator: substanceDrugsUsageItemValidator,
        },
      };
    }
    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default substanceDrugsUsageValidator;
